import { render } from "./the-footer.vue?vue&type=template&id=2486d3f7&scoped=true&ts=true"
import script from "./the-footer.vue?vue&type=script&lang=ts"
export * from "./the-footer.vue?vue&type=script&lang=ts"

import "./the-footer.vue?vue&type=style&index=0&id=2486d3f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2486d3f7"]])

export default __exports__